import { createContext, useContext } from "react";
import {
  defaultPrimaryAccentColor,
  defaultPrimaryColor,
} from "../../app_config";

export interface VisualProviderContextType {
  logoUrl: string;
  companyName: string;
  primaryColor: string;
  accentColor: string;
}

export const VisualProviderContext = createContext<VisualProviderContextType>({
  accentColor: defaultPrimaryAccentColor,
  primaryColor: defaultPrimaryColor,
  companyName: "",
  logoUrl: "",
});

export const useVisualProvider = () => {
  return useContext(VisualProviderContext);
};
